// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_55-7";
export var adjustableWidthBorderHeld = "_55-8";
export var arrow = "_55-3";
export var arrowButton = "_55-4";
export var headerCell = "_55-0";
export var help = "_55-2";
export var icon = "_55-1";
export var iconWrapper = "_55-6";
export var noBorder = "_55-b";
export var nonAdjustableWidthBorder = "_55-9";
export var nonAdjustableWidthBorderHeld = "_55-a";
export var textButton = "_55-5";